




































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import Dialog from '@/components/Dialog.vue';

@Component({
  components: {
    Dialog,
  },
})
export default class AboutDialog extends Vue {
  private show: boolean = false;
}
